export const demoData = {
  version: 1.0,
  title: "Workday Demo",
  flows: [
    {
      id: 0,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Title_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "From a Teams channel a user navigates to a vertical icon bar on the left side of the screen. The icon bar lists ten icons. Activity, Chat, Teams, Calendar, Calls, Files, Workday, and an ellipsis are at the top. The App and Help icons are at the bottom. A purple pop-up points to the Workday icon. ",
        },
      ],
    },
    {
      id: 1,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Look up any coworker",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "From a Teams channel a user navigates to a vertical icon bar on the left side of the screen. The icon bar lists ten icons. Activity, Chat, Teams, Calendar, Calls, Files, Workday, and an ellipsis are at the top. The App and Help icons are at the bottom. A purple pop-up points to the Workday icon.",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "Head to the Workday app within Teams",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "36%",
              x: "4.15%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "The Workday bot in Teams is now open, with a curser in a chat box waiting for a user to type.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: 'Type "hi" to get started',
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "82%",
              x: "4.5%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Workday_Step1a_Image2a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user types “hi” into the chat box. There is a purple pop-up over a paper-airplane icon, prompting the user to send the message.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text:
              "Click “Lookup a coworker” from the Workday card in Teams, or search any combination of the person’s first and last name to open the coworker lookup module",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "35%",
              x: "9%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Workday_Step1a_Image2a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "Workday_Step1a_Image2a.jpg",
              "Workday_Step1a_Image2b.jpg",
              "Workday_Step1a_Image2c.jpg",
              "Workday_Step1a_Image2d.jpg",
              "Workday_Step1a_Image2e.jpg",
            ],
          },
          screenReaderText:
            "A purple text box that reads “hi” appears in the chat box. In the same view, a white card appears with clickable tiles. A purple pop-up points to a tile that says “Lookup a coworker”",
        },
        {
          id: 4,
          card: {
            transition: false,
            text:
              "Search for a coworker’s name to view a Workday profile card to see a summary of their information",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "32.5%",
              x: "30%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1a_Image3a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "A white box appears with the Workday icon in the upper left-hand corner. Under the icon it reads “Look up a Coworker”. There’s a search bar titled “Who are you looking for?” A purple pop-up points to the search bar.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "36.5%",
              x: "72.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1a_Image3a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "Workday_Step1a_Image3a.jpg",
              "Workday_Step1a_Image3b.jpg",
              "Workday_Step1a_Image3c.jpg",
              "Workday_Step1a_Image3d.jpg",
              "Workday_Step1a_Image3e.jpg",
              "Workday_Step1a_Image3f.jpg",
              "Workday_Step1a_Image3g.jpg",
              "Workday_Step1a_Image3h.jpg",
              "Workday_Step1a_Image3i.jpg",
              "Workday_Step1a_Image3j.jpg",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Joy Banks” into the search bar. A purple pop-up points to a “Search” button to the right of the search bar.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text:
              "View reporting structures, and click into any employee name to see their Workday profile ",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "50%",
              x: "75.2%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1a_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "A new white box appears that lists Joy Banks’ name, a deeplink that reads “View in Workday”, job title (Chief Human Resources Officer), tenure (Has worked here for more than 4 year(s)), and Contact info (joy.banks@workday.net). There is a profile picture of Joy Banks on the right-hand side of the box. Below Joy’s information, a purple box outlines her manager and team. There are horizontal tiles for each of her team members.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "Users can also open Workday directly from the Teams app",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "87%",
              x: "7%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1a_Image7.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop up points to the “View in Workday” deeplink next to Joy’s name.",
        },
      ],
    },
    {
      id: 2,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Provide anytime feedback",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              'Click the "Give anytime feedback" tile from the Workday card to give a coworker feedback from Teams',
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "35%",
              x: "19%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Workday_Step1b_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "The Workday bot channel in Teams is open. There is a white box with clickable tiles. A purple pop-up points to a tile that reads “Give anytime feedback”.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Type the coworker’s name into the module",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "43%",
              x: "17.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Workday_Step1b_Image2a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "A white box appears with the Workday icon in the upper left-hand corner. Under the icon it reads “Give Feedback”. There’s a search bar titled “Who would you like to leave anytime feedback for?” A purple pop-up points to the search bar.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "36.5%",
              x: "73%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1b_Image2a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "Workday_Step1b_Image2a.jpg",
              "Workday_Step1b_Image2b.jpg",
              "Workday_Step1b_Image2c.jpg",
              "Workday_Step1b_Image2d.jpg",
              "Workday_Step1b_Image2e.jpg",
              "Workday_Step1b_Image2f.jpg",
              "Workday_Step1b_Image2g.jpg",
              "Workday_Step1b_Image2h.jpg",
              "Workday_Step1b_Image2i.jpg",
              "Workday_Step1b_Image2j.jpg",
            ],
          },
          screenReaderText:
            "The user types “Joy Banks” into the search bar. A purple pop-up points to a “Search” button to the right of the search bar.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Add feedback",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "41.5%",
              x: "4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Workday_Step1b_Image4a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "A new white box appears. A purple pop-up points to a box titled “Your feedback”. The box reads “What would you like to say?”",
        },
        {
          id: 5,
          card: {
            transition: false,
            text:
              "Select an optional badge from the dropdown to add some fun flair to public feedback",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "53%",
              x: "74.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1b_Image4a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "Workday_Step1b_Image4a.jpg",
              "Workday_Step1b_Image4e.jpg",
              "Workday_Step1b_Image4g.jpg",
              "Workday_Step1b_Image4k.jpg",
              "Workday_Step1b_Image4m.jpg",
              "Workday_Step1b_Image4o.jpg",
              "Workday_Step1b_Image4q.jpg",
              "Workday_Step1b_Image4u.jpg",
              "Workday_Step1b_Image4w.jpg",
              "Workday_Step1b_Image4y.jpg",
              "Workday_Step1b_Image4zc.jpg",
              "Workday_Step1b_Image4ze.jpg",
              "Workday_Step1b_Image4zg.jpg",
              "Workday_Step1b_Image4zi.jpg",
              "Workday_Step1b_Image4zm.jpg",
              "Workday_Step1b_Image4zo.jpg",
              "Workday_Step1b_Image4zq.jpg",
              "Workday_Step1b_Image4zu.jpg",
              "Workday_Step1b_Image4zx.jpg",
              "Workday_Step1b_Image4zz.jpg",
              "Workday_Step1b_Image4zzd.jpg",
              "Workday_Step1b_Image4zzg.jpg",
              "Workday_Step1b_Image4zzm.jpg",
              "Workday_Step1b_Image4zzo.jpg",
            ],
          },
          screenReaderText:
            "In the same view, there’s a dropdown titled “Badge”. A purple pop-up points to a down carrot that will expand a menu of options in a dropdown.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "69%",
              x: "30.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1b_Image5a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user clicks “Shout out” from the dropdown",
        },
        {
          id: 7,
          card: {
            transition: false,
            text:
              "Select whether the provided feedback is public or private and click “Send” (by default, feedback is public)",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "61%",
              x: "74.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1b_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, there’s a heading titled “Feedback sharing”. “Share with others” has been selected from a drop down. A purple search bar points to “Send”.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "71.5%",
              x: "73.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1b_Image6a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "The view switches back to the Workday bot in Teams. A purple outline highlights a notification that your feedback was successfully sent to Joy Banks and her manager, Steve Morgan.",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "Employees and their managers will be automatically notified when public feedback is provided",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "85%",
              x: "7%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1b_Image7.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "Employees and their managers will be automatically notified when public feedback is provided",
        },
        {
          id: 10,
          card: {
            transition: false,
            text:
              "View the feedback in the Workday browser by clicking the hyperlink in Teams",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "85%",
              x: "75.5%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step1b_Image8.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "View the feedback in the Workday browser by clicking the hyperlink in Teams",
        },
      ],
    },
    {
      id: 3,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Track time-off balances and requests",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "View a time off balance by typing “Check time off” ",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "88.5%",
              x: "17%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The Workday bot channel in Teams is open. There is a white card with clickable tiles that read “Lookup a coworker”, “Give anytime feedback”, Enter expense”, “Take time off”, View time off balance”, and “More”. A purple pop-up points to chat box, prompting the user to type.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "89%",
              x: "79%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Workday_Step2a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "Workday_Step2a_Image1.jpg",
              "Workday_Step2a_Image2a.jpg",
              "Workday_Step2a_Image2c.jpg",
              "Workday_Step2a_Image2d.jpg",
              "Workday_Step2a_Image2f.jpg",
              "Workday_Step2a_Image2h.jpg",
              "Workday_Step2a_Image2j.jpg",
              "Workday_Step2a_Image2l.jpg",
              "Workday_Step2a_Image2m.jpg",
              "Workday_Step2a_Image2n.jpg",
            ],
          },
          screenReaderText: "The user types “Check time off” in the chat box.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text:
              "Workday automatically excludes weekends, public holidays, and existing approved time off from an employee’s balance",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "79.5%",
              x: "75%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2a_Image3.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a white box appears that lists available time off. A purple box outlines this view. ",
        },
        {
          id: 4,
          card: {
            transition: false,
            text:
              "Type “Request time off” in the Workday app to begin a request",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "88.5%",
              x: "17%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2a_Image4.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the chat box.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "89%",
              x: "79%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Workday_Step2a_Image5a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "Workday_Step2a_Image4.jpg",
              "Workday_Step2a_Image5a.jpg",
              "Workday_Step2a_Image5c.jpg",
              "Workday_Step2a_Image5e.jpg",
              "Workday_Step2a_Image5g.jpg",
              "Workday_Step2a_Image5i.jpg",
              "Workday_Step2a_Image5k.jpg",
              "Workday_Step2a_Image5m.jpg",
              "Workday_Step2a_Image5o.jpg",
              "Workday_Step2a_Image5p.jpg",
            ],
          },
          screenReaderText:
            "The user types “Request time off” into the chat box. ",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "Type requested start and end dates",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "90%",
              x: "16.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2a_Image6b.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a white box appears in the chat thread, prompting the user to type the start and end dates of the request",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.5%",
              x: "92.1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2a_Image7a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "Workday_Step2a_Image7a.jpg",
              "Workday_Step2a_Image7b.jpg",
              "Workday_Step2a_Image7c.jpg",
              "Workday_Step2a_Image7e.jpg",
              "Workday_Step2a_Image7g.jpg",
              "Workday_Step2a_Image7i.jpg",
              "Workday_Step2a_Image7j.jpg",
              "Workday_Step2a_Image7l.jpg",
              "Workday_Step2a_Image7m.jpg",
            ],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the chat box",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "Select the type of time off requested from the dropdown menu",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "74.5%",
              x: "39.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2a_Image8.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "The user types “December 7-9",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "81.6%",
              x: "19%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2a_Image11.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a white card appears in the chat thread, confirming the dates of the request. A purple pop up points to a dropdown menu with various time off options.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Submit, edit, or cancel the request via the Workday card",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "74%",
              x: "42%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2a_Image12.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, four options appear in the dropdown. “Floating Holiday (Hours), Sick (Hours), U.S. Intermittent FMLA (Hours), Vacation (Hours)",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "81.8%",
              x: "19.7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2a_Image13.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user selects “Vacation (Hours) from the drop down.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text:
              "Notify managers of new requests, alerting them if another employee is scheduled to be out of the office at that time",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "66%",
              x: "42.2%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2a_Image14.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, Vacation (Hours) has been selected. A purple pop-up points to a “Next” button on the white box",
        },
        {
          id: 14,
          card: {
            transition: false,
            text:
              "Managers and employees will receive notifications in Teams throughout the process, alerting managers of requests, and employees of approvals",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "82%",
              x: "5%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Workday_Step2a_Image14a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the card has updated to confirm the time off request. There are now three buttons on the card: Submit, Edit or add details, and Cancel. A purple box outlines the card",
        },
        {
          id: 15,
          card: {
            transition: false,
            text:
              "Alternatively, select a deep link in the Workday card that will open the request in a browser directly from the app",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "82%",
              x: "75%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Workday_Step2a_Image14a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the “Submit” button",
        },
      ],
    },
    {
      id: 4,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Create expenses",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "Type “Hello” to resurface the interactive Workday card",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "56.5%",
              x: "61%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Workday_Step2b_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The Workday bot channel in Teams is open, and there is a chat thread. A purple pop-up is highlighting the word “Hello” at the bottom of the thread.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text:
              "Send automatically generated expense report items to Workday without leaving Teams by clicking the “Enter expense” tile from the Workday card",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "72%",
              x: "21.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2b_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a white card appears with clickable tiles. A purple pop-up is pointing to a tile that reads “Enter expense”",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Add a receipt image directly into the chat",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "84.2%",
              x: "5.2%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Workday_Step2b_Image3.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the “Enter expense” tile has been clicked, and the card has been updated—asking the user to upload a photo of their receipt. A purple pop-up is pointing to a paper clip icon at the bottom of the chat screen. This icon is horizontally oriented with 11 other icons.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "91%",
              x: "12.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2b_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A purple pop up is pointing to the paper clip icon.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "26%",
              x: "44.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2b_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the icon is clicked, a pop-up appears with two options: OneDrive and Upload from my computer. A purple pop-up is pointing to Upload from my computer",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "89%",
              x: "79%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Workday_Step2b_Image7a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "Workday_Step2b_Image7a.jpg",
              "Workday_Step2b_Image7b.jpg",
              "Workday_Step2b_Image7c.jpg",
              "Workday_Step2b_Image7e.jpg",
              "Workday_Step2b_Image7g.jpg",
              "Workday_Step2b_Image7i.jpg",
              "Workday_Step2b_Image7k.jpg",
              "Workday_Step2b_Image7m.jpg",
              "Workday_Step2b_Image7o.jpg",
              "Workday_Step2b_Image7q.jpg",
            ],
          },
          screenReaderText:
            "In the same view, a window appears to allow users to select a file. The window shows two receipts, with a purple pop up pointing to the first receipt.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "95%",
              x: "65.5%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Workday_Step2b_Image8.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The file window has disappeared, and the user is back in the chat thread. A file titled “Lunch receipt.jpg” has been attached to the chat box, along with a message that reads “Conference lunch”. There is a purple pop-up over the paper airplane send icon",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "95%",
              x: "65.5%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Workday_Step2b_Image9.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "An image of the receipt appears in the chat thread.",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "95%",
              x: "65.5%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Workday_Step2b_Image10.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A white card appears in the chat thread alerting the user that the bot is filing a Quick Expense.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Review the details from the uploaded image",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "75%",
              x: "42.2%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2b_Image11.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, another white card appears alerting the user that the expense has been created.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "Edit information from the receipt as needed",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "88%",
              x: "5.7%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Workday_Step2b_Image12.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "Another card appears in the chat thread titled “conference lunch” that outlines the details of the expense, including the date, amount, and title of the uploaded receipt. There are two buttons on the card: Edit and Delete. There is a purple box outlining the card.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "77.8%",
              x: "73%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2b_Image13.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the “Edit” button.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "Access the expense report from a deep link within Teams",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "57.8%",
              x: "42.2%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2b_Image14.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A large white box appears giving the user the ability to update the details of the expense. This includes an optional memo, date, expense item field, Merchant field, Amount field, and Currency dropdown. There is a purple pop-up pointing to the “Submit” button.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text:
              "With the mobile Teams app, users can upload expense report items on the go",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "86.8%",
              x: "5.2%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2b_Image15.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The view has returned to the Workday chat thread. There is a purple box outlining a tile that says the expense has been created with a deeplink to Workday.",
        },
      ],
    },
    {
      id: 5,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Leave interview feedback",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "Interview feedback",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "Type “Hello” to resurface the interactive Workday card",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "56%",
              x: "63.3%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Workday_Step2c_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The Workday bot channel in Teams is open, and there is a chat thread. A purple pop-up is highlighting the word “Hello” at the bottom of the thread.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "81.3%",
              x: "30%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2c_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a white card appears with clickable tiles. A purple pop-up is pointing to a tile that reads “More…”",
        },
        {
          id: 3,
          card: {
            transition: false,
            text:
              "Click the “Request interview feedback” tile from the Workday card to enable recruiters and hiring managers to securely review candidates without leaving Teams ",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "74.5%",
              x: "28%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2c_Image3.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "View a time off balance by typing “Check time off",
        },
        {
          id: 4,
          card: {
            transition: false,
            text:
              "See a list of all the candidates in an interview phase, as well as candidates with pending interview panel feedback",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "82.5%",
              x: "75%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2c_Image4.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "Another white card appears in the chat thread. A purple pop-up is pointing to a clickable tile that reads “Request interview feedback”",
        },
        {
          id: 5,
          card: {
            transition: false,
            text:
              "Ping interviewers in Teams to give feedback on a candidate from within the Workday app",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "82.5%",
              x: "5%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2c_Image4.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "Another white card appears in the chat thread. A purple pop-up is pointing to a clickable tile that reads “Request interview feedback”",
        },
      ],
    },
    {
      id: 6,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Ask Workday",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "Create self-service opportunities, quick summaries, and deep links for common Workday tasks by configuring the Workday Assistant module in Teams",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "78.5%",
              x: "5%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2d_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The Workday bot channel in Teams is open, and there is a chat thread. At the bottom of the thread, there’s a white card with clickable tiles.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Type “Hello” to resurface the interactive Workday card",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "28.5%",
              x: "63%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Workday_Step2d_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up is highlighting the word “Hello” in the thread above the white card.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text:
              "Click “More” to pull up Ask Workday, Workday’s virtual assistant",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "60%",
              x: "16.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Workday_Step2d_Image3.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up is pointing to a clickable tile on the white Workday card that reads “More…”",
        },
        {
          id: 4,
          card: {
            transition: false,
            text:
              "Click “Ask Workday”, to view all modules available within the Workday tenant ",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "70.5%",
              x: "20%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Workday_Step2d_Image4.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "Another white card appears in the chat thread. A purple pop-up is pointing to a clickable tile that reads “Ask Workday”",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "70.5%",
              x: "20%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step2d_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The card reloads, and presents a bullet list of keywords the user can enter into the Workday bot.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text:
              "Type questions or keywords into the Workday app, then review the Workday assistant-provided quick summaries or Workday deep links",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "73.5%",
              x: "4%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Workday_Step2d_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the chat box, prompting the user to type a keyword into the chat.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "89%",
              x: "79%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Workday_Step2d_Image7a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "Workday_Step2d_Image6.jpg",
              "Workday_Step2d_Image7a.jpg",
              "Workday_Step2d_Image7a.jpg",
              "Workday_Step2d_Image7c.jpg",
              "Workday_Step2d_Image7e.jpg",
              "Workday_Step2d_Image7g.jpg",
              "Workday_Step2d_Image7i.jpg",
            ],
          },
          screenReaderText: "The user types “View W-4” into the chat box.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text:
              "The Workday app understands the user request, surfacing actionable deep links",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "84.5%",
              x: "75.8%",
            },
            beacon: {
              isVisible: false,
              position: "bottom",
            },
          },
          images: {
            name: ["Workday_Step2d_Image9.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "View W-4” now appears in the thread. A new tile appears in the chat thread, providing the user with a deep link that reads “Withholding Elections”. ",
        },
      ],
    },
    {
      id: 7,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Get the Workday app in the Teams store",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "Head to the Teams store to get started",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "88.2%",
              x: "4.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step3_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "From a Teams channel a user navigates to a vertical icon bar on the left side of the screen. The icon bar lists ten icons: Activity, Chat, Teams, Calendar, Calls, Files, Workday, and an ellipsis are at the top. An app and help icon are at the bottom. A purple pop-up points to the App icon.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Search the Teams Store for the Workday app",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "9.5%",
              x: "14.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step3_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new screen appears showing the Microsoft Teams app store. There is a purple pop up pointing to a search bar.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Click the Workday tile",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "11.5%",
              x: "37.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step3_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "Workday_Step3_Image3a.jpg",
              "Workday_Step3_Image3b.jpg",
              "Workday_Step3_Image3c.jpg",
              "Workday_Step3_Image3d.jpg",
              "Workday_Step3_Image3e.jpg",
              "Workday_Step3_Image3f.jpg",
              "Workday_Step3_Image3g.jpg",
              "Workday_Step3_Image4.jpg",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Workday” into the search bar.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Install the app",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "34.5%",
              x: "22%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Workday_Step3_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop up points to the Workday tile.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text:
              "Sign in to Workday directly from the app to start accomplishing common HR tasks without leaving Teams",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "41%",
              x: "26%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Workday_Step3_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A large white box appears on the screen explaining the Workday app. There’s a purple pop-up pointing to a button that says “Install”.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text:
              "Work with your Teams admin to pin the Workday app to the menu bar for your entire organization, displaying the tools most relevant to your users",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "81%",
              x: "6%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_Step3_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The Workday bot chat window is now open. There’s a white card with a purple pop-up pointing to a button that reads “Sign in”.",
        },
      ],
    },
    {
      id: 0,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Workday_end_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
  ],
};
